<template>
    <PageHeader
        :title="online ? $t('games.select_online_title') : $t('games.select_title')"
        @back="goBack"
    />

    <div class="flex flex-col gap-6 py-8">
        <div class="px-4" v-if="showClassicGames">
            <h2 class="panel-title">{{ $t('games.the_classics') }}</h2>
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                <X01Banner v-if="!online || x01Game.onlineAvailable" :online="online" />
                <CricketBanner v-if="!online || cricketGame.onlineAvailable" :online="online" />
            </div>
        </div>

        <div class="px-4" v-if="showMinigames">
            <h2 class="panel-title">{{ $t('games.minigames') }}</h2>
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                <CamelraceBanner v-if="!online || camelraceGame.onlineAvailable" :online="online" />
                <KillerBanner v-if="!online || killerGame.onlineAvailable" :online="online" />
                <SegmentsBanner v-if="!online || segmentsGame.onlineAvailable" :online="online" />
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import X01Banner from '@/components/ui/banners/Games/X01.vue'
import CricketBanner from '@/components/ui/banners/Games/Cricket.vue'
import CamelraceBanner from '@/components/ui/banners/Games/Camelrace.vue'
import KillerBanner from '@/components/ui/banners/Games/Killer.vue'
import SegmentsBanner from '@/components/ui/banners/Games/Segments.vue'
import x01Game from '@/services/games/1_x01'
import cricketGame from '@/services/games/2_cricket'
import camelraceGame from '@/services/games/3_camelrace'
import killerGame from '@/services/games/4_killer'
import segmentsGame from '@/services/games/5_segments'

export default {
    name: 'GameSelectionView',
    components: {
        PageHeader,
        X01Banner,
        CricketBanner,
        CamelraceBanner,
        KillerBanner,
        SegmentsBanner,
    },
    props: {
        /** Filter to only online-eligible games (Play Online > Private Match). */
        online: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        goBack() {
            this.$router.back()
        },
    },
    computed: {
        x01Game: () => x01Game,
        cricketGame: () => cricketGame,
        camelraceGame: () => camelraceGame,
        killerGame: () => killerGame,
        segmentsGame: () => segmentsGame,
        showClassicGames() {
            return (
                !this.online ||
                this.x01Game.onlineAvailable ||
                this.cricketGame.onlineAvailable
            )
        },
        showMinigames() {
            return (
                !this.online ||
                this.camelraceGame.onlineAvailable ||
                this.killerGame.onlineAvailable ||
                this.segmentsGame.onlineAvailable
            )
        },
    },
}
</script>
